<template>
  <Itcregister v-if="loginScene == 2" />
  <Huiyiregister v-else-if="loginScene == 1" />
</template>

<script>
import Itcregister from "./itc-register";
import Huiyiregister from "./huiyi-register";
export default {
  components: {
    Itcregister,
    Huiyiregister,
  },
  data() {
    return {
      loginScene:parseInt(sessionStorage.getItem("isItcScene")) || this.$store.getters.isItcScene,
    };
  },
  created() {
    // 以防万一没有在加载页获取到场景时，重新获取场景
    if (this.loginScene == undefined) {
        this.getScene();
    }
  },
  methods: {
    getScene() {
      const success = (res) => {
        let number1 = res.data;
        sessionStorage.setItem("isItcScene", number1);
        this.$store.commit("SET_ISITCSCENCE", number1);
        this.loginScene = number1
        console.log('register', this.loginScene)
        if (number1) {
          // 修改element ui 主题颜色
          // this.toggleClass(document.body,'custom-E62125')
        } else {
          // this.toggleClass(document.body,'custom-409EFF')
        }
      };
      const fail = (res) => {};
      this.$ajax.get("api/login/frontVersion", { func: { success, fail } });
    }
  },
};
</script>

<style lang="scss" scoped>
</style>
